import styled from 'styled-components';

const SelectionBox = styled.div<{
  startX: number;
  currentX: number;
  top: number;
  height: number;
}>`
  position: absolute;
  top: ${({ top }) => top}px;
  left: ${({ startX, currentX }) => Math.min(startX, currentX)}px;
  width: ${({ startX, currentX }) => Math.abs(currentX - startX)}px;
  height: ${({ height }) => height}px;
  border: 1px dashed ${({ theme }) => theme.palette.accent.link};
  background-color: ${({ theme }) => theme.palette.accent.link}10;
  pointer-events: none;
  z-index: 2;
`;

type ChartSelectionOverlayProps = {
  startX: number | null;
  currentX: number | null;
  top?: number;
  height?: number;
};

const ChartSelectionOverlay = ({
  startX,
  currentX,
  top = 60,
  height = 228,
}: ChartSelectionOverlayProps) => {
  if (startX == null || currentX == null) return null;

  return (
    <SelectionBox
      startX={startX}
      currentX={currentX}
      top={top}
      height={height}
    />
  );
};

export default ChartSelectionOverlay;
